import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-channal-icon',
  templateUrl: './channal-icon.component.html',
  styleUrls: ['./channal-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannalIconComponent implements OnDestroy {
  @Input() channal: Channals;
  @Input() gray: boolean;
  
 private destroy$ = new Subject<void>();
  constructor() { }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}


enum Channals {
  Amazon = "amazon",
  Ebay = "ebay",
  Walmart = "walmart",
  Wish = "wish",
  Newegg = "newegg",
  Shopify="shopify",
  Wholesale="wholesale",
  Wayfair="wayfair",
  WooCommerce="wooCommerce",
  BigCommerce="bigcommerce"
}